module.exports = __webpack_public_path__ + "static/QRcard-e6655e3000ca2c3fa88324044734774d.png";